import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { DateEditComponent } from './dateedit.component';
import { DateEditRoutingModule } from './dateedit.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DateEditRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    DateEditComponent
  ],
  declarations: [
    DateEditComponent
  ]
})
export class DateEditModule { }
